import React from 'react';
import { WHY_PITBOARD, WHY_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

export default function WhyPitboard() {
  const { lang }  = useLanguage();
  const items     = WHY_PITBOARD[lang];
  const header    = WHY_HEADER[lang];

  return (
    <section
      className="pb-section pb-section-pad"
      id="pourquoi"
      style={{ background: 'var(--pb-deep-blue)' }}
      data-testid="pb-why"
    >
      <div className="pb-container">
        <div style={{ maxWidth: 560 }}>
          <div className="pb-label" style={{ color: 'rgba(255,255,255,0.45)' }}>
            {header.label}
          </div>
          <h2 className="pb-section-title" style={{ color: '#fff' }}>
            {header.title.split('\n').map((line, i) => (
              <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
            ))}
          </h2>
          <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.55)', lineHeight: 1.75, marginTop: 16 }}>
            {header.sub}
          </p>
        </div>

        <div className="pb-why-grid">
          {items.map(item => (
            <div key={item.num} className="pb-why-card" data-testid={`pb-why-${item.num}`}
              style={{ background: 'rgba(255,255,255,0.04)', borderColor: 'rgba(255,255,255,0.08)' }}
            >
              <div className="pb-why-number" style={{ color: 'rgba(255,255,255,0.05)', WebkitTextStroke: '1px rgba(255,255,255,0.1)' }}>
                {item.num}
              </div>
              <div className="pb-why-title-card" style={{ color: '#fff' }}>{item.title}</div>
              <p className="pb-why-desc" style={{ color: 'rgba(255,255,255,0.55)' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        #pourquoi .pb-why-card:hover { background: rgba(255,255,255,0.07) !important; border-color: rgba(255,255,255,0.15) !important; }
        #pourquoi .pb-why-card:hover::before { opacity: 0.4 !important; }
      `}</style>
    </section>
  );
}
